document.addEventListener("DOMContentLoaded", function () {
  const slides = document.querySelectorAll(".custom-slider .slide");
  if (!slides.length) return; // ⬅️ nothing to do on pages without a slider

  const next = document.querySelector(".custom-slider .next");
  const prev = document.querySelector(".custom-slider .prev");

  let index = 0;
  let autoSlide;

  slides.forEach((slide) => {
    slide.classList.remove("active");
    slide.style.display = "none";
  });

  slides[0].style.display = "flex";

  function showSlide(i) {
    slides.forEach((slide, idx) => {
      slide.style.display = (idx === i) ? "flex" : "none";
    });
  }

  function startAutoSlide() {
    autoSlide = setInterval(() => {
      index = (index + 1) % slides.length;
      showSlide(index);
    }, 500000);
  }

  function stopAutoSlide() {
    clearInterval(autoSlide);
  }

  next?.addEventListener("click", () => {
    stopAutoSlide();
    index = (index + 1) % slides.length;
    showSlide(index);
    startAutoSlide();
  });

  prev?.addEventListener("click", () => {
    stopAutoSlide();
    index = (index - 1 + slides.length) % slides.length;
    showSlide(index);
    startAutoSlide();
  });

  startAutoSlide();
});